export const renderName = (user: any) => {
  const lastInitial = user?.lastName?.[0] ?? "-";
  const firstName = user?.firstName ?? "-";

  return lastInitial === "-" && firstName === "-" ? "-" : `${lastInitial}.${firstName}`;
};
